import { FormikErrors, FormikTouched } from "formik";
import { useCallback } from "react";
import { CustomDatePickerSource } from "../../../../enums/CustomDatePicker";
import { dispatchCustomEvent } from "../../../../services/widgetEventsService";
import { WidgetGATriggerEvents } from "../../../../enums/WidgetEvents";
import CustomDateFields from "../../../CustomDayPicker/CustomDateFields";
import { PackagesSearchParams } from "../../../../types/packages/PackagesSearchParams";
import { InputKey, useWizardContext } from "../../../../contexts/packages/WizardContext";
import { Breakpoint } from "../../../../enums/Breakpoint";
import useMedia from "../../../../hooks/useMedia";

interface Props {
  errors: FormikErrors<PackagesSearchParams>;
  touched: FormikTouched<PackagesSearchParams>;
  onChange(valuesChanges: Record<string, any>, shouldValidate?: boolean): void;
  values: PackagesSearchParams;
}

const HotelDateField = ({ errors, touched, onChange, values }: Props) => {
  const { inputRefs, isWizard, mobileModalAnimations, setInputRef, stopWizard } =
    useWizardContext();
  const isMaxTablet = useMedia(Breakpoint.MaxTablet);

  const handleDayClick = useCallback(
    (date: Date, source: CustomDatePickerSource, isSelectingFirstDay: boolean) => {
      if (source === CustomDatePickerSource.FROM_DATE || isSelectingFirstDay) {
        dispatchCustomEvent({
          widgetEvent: WidgetGATriggerEvents.PackagesDepartureDateSelected,
          details: { date },
        });
        onChange({ departureDate: date, returnDate: undefined }, false);
      } else {
        dispatchCustomEvent({
          widgetEvent: WidgetGATriggerEvents.PackagesReturnDateSelected,
          details: { date },
        });
        onChange({ returnDate: date });
        if (isWizard) {
          inputRefs.current.roomCount?.click();
        }
      }
    },
    [inputRefs, isWizard, onChange]
  );

  return (
    <CustomDateFields
      ref={setInputRef(InputKey.DepartureDate)}
      onChange={handleDayClick}
      shouldShowRange={true}
      errors={errors}
      touched={touched}
      values={values}
      fromPlaceholderLabel="tix_search_form_package_departure_date"
      toPlaceholderLabel="tix_search_form_package_return_date"
      fromFieldName="departureDate"
      toFieldName="returnDate"
      mobileModalAnimations={mobileModalAnimations}
      onMobileModalClose={stopWizard}
      isSingleField={isMaxTablet}
    />
  );
};

export default HotelDateField;
